import { useCallback, useSyncExternalStore } from 'react'

/**
 * Indica se a media query casa com a viewport atual e re-renderiza quando
 * deixa de casar (ou passa a). Sem `matchMedia` (jsdom), retorna `false`.
 */
export function useMediaQuery(query: string): boolean {
    const assinar = useCallback(
        (avisar: () => void) => {
            if (!window.matchMedia) return () => {}
            const lista = window.matchMedia(query)
            lista.addEventListener('change', avisar)
            return () => lista.removeEventListener('change', avisar)
        },
        [query],
    )

    return useSyncExternalStore(
        assinar,
        () => window.matchMedia?.(query).matches ?? false,
    )
}
